import React, { useState } from "react";
import logo from "../assets/images/Logo/web_logo.png";
import { EmailInput } from "../components/form/inputs";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { Link, useNavigate } from "react-router-dom";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import { useSelector, useDispatch } from "react-redux";
import { forgotPassword } from "../redux/thunks/loginThunk";
import toast from "react-hot-toast";

const Forgotpass = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const navigate = useNavigate();

  const { isLoading } = useSelector((state) => state.login);

  const validateEmail = () => {
    if (!email) {
      setEmailErr("Email is required");
      return false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailErr("Enter a valid email");
      return false;
    }
    setEmailErr("");
    return true;
  };

  const handleSendOTP = async () => {
    const isValid = validateEmail();

    if (!isValid) {
      document.getElementById("email")?.focus();
      return;
    }

    const payload = { email };

    try {
      const res = await dispatch(forgotPassword(payload)).unwrap();

      if (res.success) {
        toast.success(res.message || "OTP sent successfully");
        // console.log("Entered try block SUCCESS");
        navigate("/otp-varify");
      } else {
        toast.error(res.message || "Email send failed");
        // console.log("Entered try block ELSE");
      }
    } catch (err) {
      // console.log("Catch block error:", err);
      toast.error(err || "Something went wrong");
    }
  };

  return (
    <section className="min-h-screen relative overflow-hidden flex items-center justify-center px-4 sm:px-6 lg:px-20 bg-gray-50 lg:bg-gradient-to-br lg:from-orange-50 lg:to-orange-100">
      <DecorativeSquares />

      {/* Card */}
      <div className="w-full max-w-md bg-transparent md:bg-white rounded-2xl shadow-none md:shadow-lg px-6 py-8 sm:px-8 sm:py-10 space-y-6">
        {/* Logo & Tagline */}
        <div className="flex flex-col items-center gap-2">
          <img src={logo} alt="web_logo" className="w-20 h-20 object-contain" />
          <p className="text-gray-400 text-sm text-center">
            You Cook, We Manage the Rest
          </p>
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-center text-gray-800">
          Forgot Password?
        </h2>
        <p className="text-gray-400 text-sm text-center">
          Enter your email to reset your password using OTP.
        </p>

        {/* Form */}
        <div className="space-y-4">
          <EmailInput
            label="Email Address"
            id="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (emailErr) validateEmail(); // real-time error clearing
            }}
            placeholder="Enter your email"
            required
            error={emailErr}
          />
        </div>

        {/* Button */}
        <div className="flex justify-center mt-2">
          <PrimaryBtn
            btnName="Send OTP"
            clickEvent={handleSendOTP}
            isLoading={isLoading}
          />
        </div>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500">
          Back to{" "}
          <Link
            to={"/login"}
            className="text-[#FF6943] cursor-pointer hover:underline"
          >
            Login
          </Link>
        </p>
      </div>
    </section>
  );
};

export default Forgotpass;
